import { Endpoints } from "../../network";
import authorToolApiClient from "../authorToolBase";
import apiClient from "../base";
import baseForPdf from "../readerBase";

export interface LiveModule {
  title: string;
  description: string;
}

export interface LiveExtra {
  [key: string]: any;
}

export interface LiveMeta {
  seo_title?: string;
  [key: string]: any;
}

export interface CreateLivePayload {
  title: string;
  description: string;
  author_name: string;
  author_zl_uid: string;
  category: string;
  category_id: string;
  date: string;
  start_time: string;
  end_time: string;
  iframe: string;
  status: string;
  modules: LiveModule[];
  extra?: LiveExtra;
  meta?: LiveMeta;
  thumbnail?: any;
  slug?: string;
}
const toFormData = (data: Record<string, any>): FormData => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((val) => {
        formData.append(
          `${key}[]`,
          typeof val === "object" ? JSON.stringify(val) : val
        );
      });
    } else if (typeof value === "object" && !(value instanceof File)) {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });

  return formData;
};

export const getGlobalCategories = async () => {
  const response = await apiClient.get(`${Endpoints.getGlobalCategories}`);

  return response?.data;
};

export const createLive = async (data: CreateLivePayload) => {
  const formData = toFormData(data);

  const response = await authorToolApiClient.post(
    `${Endpoints.createLive}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

export const editLive = async (data: CreateLivePayload, id: string) => {
  const formData = toFormData(data);

  const response = await authorToolApiClient.post(
    `${Endpoints.editLive}/${id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

export const getAllAuthors = async () => {
  const response = await baseForPdf.get(`${Endpoints.getAllAuthors}`);
  return response?.data;
};

export const getAllLives = async (statusFilter: string) => {
  const response = await authorToolApiClient.get(
    `${Endpoints.getAllLives}?status=${statusFilter}`
  );
  return response?.data;
};

export const getLiveDetails = async (id: string) => {
  const response = await authorToolApiClient.get(
    `${Endpoints.getLiveDetails}/${id}`
  );
  return response?.data;
};

export const deleteLive = async (id: string) => {
  const response = await authorToolApiClient.delete(
    `${Endpoints.deleteLive}/${id}`
  );
  return response?.data;
};

export const editStatus = async (id: string, status: string) => {
  const response = await authorToolApiClient.post(
    `${Endpoints.editLive}/${id}`,
    {
      status: status,
    }
  );
  return response?.data;
};
